module.exports = __webpack_public_path__ + "static/media/cyber-attacks.69f09e61.svg";